'use strict';

angular.module('programme')

.config(function ($stateProvider)
{
    $stateProvider.state('programme', {
        url: '/programme/:programmeSlug',
        views: {
            header: {
                templateUrl: 'modules/programme/components/header/programmeHeader.html',
                controller: 'ProgrammeHeaderCtrl'
            },
            footer: {
                templateUrl: 'modules/programme/components/footer/programmeFooter.html',
                controller: 'ProgrammeFooterCtrl'
            },
            '': {
                template: '<ui-view></ui-view>',
                controller: function($scope, $state)
                {
                    $scope.state = $state;

                    $scope.$watch('state.current', function(v)
                    {
                        if(v.name === 'programme') {
                            $state.go('programme.contents', {}, {location: 'replace'});
                        }

                    }, true);
                }
            }
        },
        redirectTo: 'programme.contents',
        resolve: {
            programme: function (Programme, $stateParams, $q, $state, programmes) {
                return Programme.findAll({
                    with: [
                        'categories.asset',
                        'categories.assetMobile',
                        'parent.children',
                        'children',
                    ].join(','),
                    where: {
                        slug: $stateParams.programmeSlug
                    }
                }, {bypassCache: false}).then(function (list) {

                    var p = list[0] ? list[0] : null;

                    if (!p) {
                        return $q.reject('No programme found with slug [' + $stateParams.programmeSlug + '].')
                                 .then($state.go('guest.login'));
                    }

                    programmes.setCurrentLanguage(p.language);
                    programmes.setCurrentTheme(p.theme);

                    return p;
                });
            }
        }
    });

    $stateProvider.state('programme.contents', {
        url: '/contents',
        templateUrl: 'modules/programme/programmeContents.html',
        controller: function ($scope, $rootScope, programme)
        {
            $scope.programme = programme;
            $rootScope.programme = $scope.programme;

            $scope.categories = programme.getCategories();

            if (programme.layout === 'hero') {
                $scope.hero = $scope.categories[0];
                $scope.categories.splice(0, 1);
            }
        },
        resolve: {
            articles: function(Article, programme) {

                var categories = programme.getCategories();

                return Article.findAll({
                    with: [
                        'asset',
                        'assetMobile',
                        'pages'
                    ].join(','),
                    sort: 'display_order',
                    where: {
                        category_id: {
                            in: categories.map(function (item) { return item.id; }),
                        },
                    }
                }, {bypassCache: false});
            }
        }
    });

    $stateProvider.state('programme.category', {
        url: '/:categorySlug',
        templateUrl: 'modules/programme/categoryState.html',
        controller: function ($scope, $rootScope, category, categories, programme, $state)
        {
            $scope.category = category;
            $rootScope.category = $scope.category;
            $scope.categories = categories;
            $scope.programme = programme;
            $rootScope.programme = $scope.programme;            
            $scope.articles = category.getArticles();

			if ($scope.articles.length === 1) {
				$state.go('programme.category.article.page', {articleSlug: $scope.articles[0].slug});
				return;
			}

            $scope.heroArticle = null;
            $scope.featuredArticles = [];
            $scope.secondaryArticles = [];
            $scope.gridArticles = [];

            angular.forEach($scope.articles, function(a)
            {
                if (!$scope.heroArticle) {
                    $scope.heroArticle = a;
                    return;
                }

                $scope.gridArticles.push(a);

                if ($scope.featuredArticles.length < 2) {
                    $scope.featuredArticles.push(a);
                    return;
                }

                $scope.secondaryArticles.push(a);
            });
        },
        resolve: {
            categories: function (Category, $stateParams, $q, programme) {
                return Category.findAll({
                    with: [
                        'asset',
                        'assetMobile',
                        'articles.asset',
                        'articles.assetMobile'
                    ].join(','),
                    where: {
                        programme_id: programme.id,
                    }
                }, {bypassCache: false});
            },
            category: function (Category, $stateParams, categories, programme, $q) {

                var list = Category.filter({
                    programme_id: programme.id,
                    slug: $stateParams.categorySlug
                });

                if (list[0]) {
                    return list[0];
                }

                return $q.reject('No category found with slug [' + $stateParams.categorySlug + '].');
            }
        }
    });

    $stateProvider.state('programme.category.article', {
        url: '/:articleSlug',
        views: {
            '@programme': {
                templateUrl: 'modules/programme/articleState.html',
                controller: function ($scope, article)
                {
                    $scope.article = article;
                }
            }
        },
        resolve: {
            articles: function (Article, $stateParams, $q, category)
            {
                return Article.findAll({
                    with: [
                        'asset',
                        'assetMobile',
                        'pages'
                    ].join(','),
                    where: {
                        category_id: category.id,
                    }
                }, {bypassCache: false});
            },
            article: function (Article, articles, $stateParams, $q, category)
            {
                var list = Article.filter({
                    category_id: category.id,
                    slug: $stateParams.articleSlug
                });

                if (list[0]) {
                    return list[0];
                }

                return $q.reject('No article found with slug [' + $stateParams.articleSlug + '].');
            },
            pages: function (article)
            {
                return article.getPages();
            }
        }
    });

    $stateProvider.state('programme.category.article.page', {
        url: '/page/:pageNum',
        params: {
            pageNum: "1"
        },
        template:
            '<article-page model="page"></article-page>' +
            '<article-page-nav pages="pages" current-page="currentPage"></article-page-nav>' +
            '<article-nav programme="programme" article="article" articles="articles" categories="categories"></article-nav>',
        controller: function ($scope, $rootScope, pages, page, $stateParams, programme, articles, article, categories, currentArticleState)
        {
            $scope.programme = programme;
            $rootScope.programme = $scope.programme; // za programme.routes
            $scope.categories = categories;
            $scope.articles = articles;
            $scope.article = article;
            $scope.page = page;
            $scope.pages = pages;
            $scope.currentPage = parseInt($stateParams.pageNum);


            currentArticleState.article = article;
            currentArticleState.currentPage = $scope.currentPage;

        },
        resolve: {
            page: function ($stateParams, pages, $q)
            {
                var pageIndex = $stateParams.pageNum - 1;
                if (pages[pageIndex]) {
                    return pages[pageIndex];
                }

                return $q.reject('No page found with index [' + pageIndex + '].');
            }
        }
    });

    $stateProvider.state('templateEdit', {
        url: '/templateEdit/:id',
        views: {
            header: {
                templateUrl: 'modules/programme/components/header/programmeHeader.html',
                controller: 'ProgrammeHeaderCtrl'
            },
            footer: {
                templateUrl: 'modules/programme/components/footer/programmeFooter.html',
                controller: 'ProgrammeFooterCtrl'
            },
            '': {
                template: '<article-page model="template"></article-page>',
                controller: function ($scope, template)
                {
                    $scope.template = template;
                }
            }
        },
        resolve: {
            template: function ($stateParams, $q, Template)
            {
                return Template.find($stateParams.id);
            },
            programme: function()
            {
                return null;
            }
        }
    });
})

.run(function($rootScope, $timeout, $document) {
    
    var defaultTitle = 'UEFA Technical Reports';

    var defaultDescription = "UEFA Technical Reports offer detailed tournament analysis, coaching insights, and technical trends shaping elite European football.";

    $rootScope.$on('$stateChangeSuccess', function(event, toState, toParams, fromState, fromParams) {
        
        $timeout(function() {
            var title = defaultTitle;

            if ($rootScope.programme && $rootScope.programme.short_title) {
                title += ' | ' + $rootScope.programme.short_title;
            }
            
            if ($rootScope.programme && $rootScope.programme.title) {
                title += ' | ' + $rootScope.programme.title;
            }
            
            if ($rootScope.category && $rootScope.category.title) {
                title += ' | ' + $rootScope.category.title;
            }

            $document[0].title = title;

            var description = defaultDescription;

            if ($rootScope.programme && $rootScope.programme.description) {
                description = $rootScope.programme.description;
            }

            if ($rootScope.category && $rootScope.category.description) {
                description = $rootScope.category.description;
            }

            var descTag = $document[0].querySelector('meta[name="description"]');
            if (descTag) {
                descTag.setAttribute('content', description);
            }

        }, 0);

    });
});
